import React, { useState } from 'react'
import { AntTabs, AntTab } from './common/Tabs'
import { DashboardAthenaTable } from './DashboardAthenaTable'
import {
  resourceLicensesCols,
  resourceEducationCols,
  resourceEmploymentHistoryCols
} from '../constants/ResourceCols'

const tabs = [
  { display: 'Licenses/Credentials', value: 0 },
  { display: 'Education', value: 1 },
  { display: 'Employment History', value: 2 }
]

export default function ResourceTalentProfile(props) {
  const [value, setValue] = useState(0)
  const { headers, tableRefreshKey } = props

  const handleChange = (event, newValue) => {
    setValue(newValue)
  }

  return (
    <>
      <AntTabs
        color={props.fetchInitialData.credentials.primaryAppColor}
        value={value}
        onChange={handleChange}
        aria-label='talent profile tabs'
      >
        {tabs.map((cur, index) => (
          <AntTab
            key={index}
            label={cur.display}
            value={cur.value}
            color={props.fetchInitialData.credentials.primaryAppColor}
          />
        ))}
      </AntTabs>
      {value === 0 && (
        <div style={{ marginTop: '1rem' }}>
          <DashboardAthenaTable
            {...props}
            isTempTable={false}
            key={`licenses-${tableRefreshKey}`}
            params={{ ...headers }}
            tableColumns={resourceLicensesCols}
            reportName='hr_resource_talent_licenses'
          />
        </div>
      )}
      {value === 1 && (
        <div style={{ marginTop: '1rem' }}>
          <DashboardAthenaTable
            {...props}
            isTempTable={false}
            key={`education-${tableRefreshKey}`}
            params={{ ...headers }}
            tableColumns={resourceEducationCols}
            reportName='hr_resource_talent_education'
          />
        </div>
      )}
      {value === 2 && (
        <div style={{ marginTop: '1rem' }}>
          <DashboardAthenaTable
            {...props}
            isTempTable={false}
            key={`employment-history-${tableRefreshKey}`}
            params={{ ...headers }}
            tableColumns={resourceEmploymentHistoryCols}
            reportName='hr_resource_talent_employment_history'
          />
        </div>
      )}
    </>
  )
}
